import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import logo from 'Assets/cloud.svg';
import mail from 'Assets/mail.svg';
import phone from 'Assets/phone.svg';
import telegram from 'Assets/telegram.svg';

const useStyles = makeStyles()((theme) => ({
  logo: {
    height: theme.spacing(7),
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
  },
  smallLogo: {
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
  },
  footerText: { 
    display: 'flex',
    alignItems: 'center',
  },
  footerItem: { 
    margin: theme.spacing(1, 2.5),
    whiteSpace: 'nowrap',
  },
  phoneItem: {
    margin: theme.spacing(1, 1.5),
    marginLeft: theme.spacing(1.5),
    whiteSpace: 'nowrap',
  },
  footerLink: {
    textDecoration: 'none',
    fontWeight: 'lighter',
    color: theme.palette.text.secondary,
    '&:hover, &:visited': { color: theme.palette.text.secondary },
  },
  header: { 
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
  },
  contactsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  legalLinks: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    flexWrap: 'wrap',
    paddingTop: theme.spacing(3),
    borderTop: `1px solid ${theme.palette.text.secondary}`,
  },
  legalLinkItem: {
    margin: theme.spacing(0, 2),
  },
}));

export default function LandingFooter() {
  const { classes } = useStyles();
  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%" bgcolor="text.primary" pb={3}>
      {/* Контакты */}
      <Typography variant="h5" color="textSecondary" className={classes.header}>
        Наши контакты
      </Typography>
      
      <Box className={classes.contactsContainer}>
        <a href="https://t.me/PrintMiptSupport" target="_blank" rel="noopener noreferrer" className={classes.footerLink}>
          <Box className={classes.footerItem}>
            <Box className={classes.footerText}>
              <img src={telegram} className={classes.smallLogo} alt="Telegram" />
              <Typography variant="body1">@PrintMiptSupport</Typography>
            </Box>
          </Box>
        </a>
        
        <Box className={classes.phoneItem}>
          <Box className={classes.footerText}>
            <img src={phone} className={classes.smallLogo} alt="Phone" />
            <Typography variant="body1">+7 (916) 015-84-00</Typography>
          </Box>
        </Box>

        <Box className={classes.footerItem}>
          <Box className={classes.footerText}>
            <img src={mail} className={classes.smallLogo} alt="Email" />
            <Typography variant="body1">info@printmipt.ru</Typography>
          </Box>
        </Box>
      </Box>
      
      {/* Юридические ссылки */}
      <Box className={classes.legalLinks}>
        <Typography variant="body2" className={classes.legalLinkItem}>
          <a href="/user-agreement" className={classes.footerLink}>
            Пользовательское соглашение
          </a>
        </Typography>
        <Typography variant="body2" className={classes.legalLinkItem}>
          <a href="/privacy-policy" className={classes.footerLink}>
            Политика конфиденциальности
          </a>
        </Typography>
        <Typography variant="body2" className={classes.legalLinkItem}>
          <a href="/payments-info" className={classes.footerLink}>
            Об оплате
          </a>
        </Typography>
      </Box>
    </Box>
  );
}